import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    maxHeight: "100%",
    overflow: "hidden",
  },
  stickyHeader: {
    position: "sticky",
    top: 0,
    zIndex: 10,
    backgroundColor: tokens.colorNeutralBackground1,
    paddingBottom: "12px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    flexShrink: 0,
  },
  scrollableContent: {
    flex: 1,
    overflow: "auto",
    minHeight: 0,
  },
  changesList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  changeItem: {
    padding: "12px",
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    borderRadius: "8px",
    backgroundColor: tokens.colorNeutralBackground2,
  },
  changeItemIgnored: {
    backgroundColor: tokens.colorPaletteRedBackground2,
  },
  changeItemSelected: {
    backgroundColor: tokens.colorPaletteGreenBackground2,
  },
  citationText: {
    fontWeight: "600",
    fontSize: "14px",
    color: tokens.colorNeutralForeground1,
  },
  changeDescription: {
    fontSize: "13px",
    color: tokens.colorNeutralForeground2,
    marginTop: "4px",
  },
  resolvedTo: {
    fontSize: "13px",
    color: tokens.colorPaletteGreenForeground1,
    marginTop: "4px",
    fontStyle: "italic",
  },
  buttonContainer: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
    padding: "16px 0",
    borderTop: `1px solid ${tokens.colorNeutralStroke1}`,
    marginTop: "auto",
    flexShrink: 0,
  },
  summaryBox: {
    padding: "12px 16px",
    backgroundColor: tokens.colorNeutralBackground2,
    borderRadius: "4px",
    display: "flex",
    gap: "24px",
    justifyContent: "center",
  },
  summaryItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
    padding: "40px",
  },
});
